import { gql } from "@apollo/client";

const GET_CATEGORIES = gql`
  query GetCategories($levelId: ID) {
    categories(levelId: $levelId) {
      id
      name
      skippedIfSpokenOnly
    }
  }
`;

export default GET_CATEGORIES;
